import axios from 'axios';

/**
 * @namespace Utils
 * @method $http
 * @exports Utils/$http
 * @description Util giving http access using axios
 * @date 2020/02/21
 * @license no license
 * @copywrite Answers In Retirement Limited
 */

const config = {
	baseURL: process.env.VUE_APP_API_URL,
	headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/json' }
};

const $http = axios.create(config);

const cacheInterceptor = request => {
  if (process.env.VUE_APP_CACHE_URL && request.cache) {
    request.apiPath = request.url;
    request.url = `${process.env.VUE_APP_CACHE_URL}/${request.cachePath}`;
    request.apiMethod = request.method;
    request.method = 'get';
    request.apiData = request.data;
    delete request.data;
  }
  return request;
};

$http.interceptors.request.use(cacheInterceptor);

$http.interceptors.response.use(
  response => {
    return response;
  },
  async error => {
    if (error.config.cache && error.config.url === `${process.env.VUE_APP_CACHE_URL}/${error.config.cachePath}`) {
      error.config.cache = false;
      error.config.url = error.config.apiPath;
      error.config.method = error.config.apiMethod;
      if (error.config.apiData) {
        error.config.data = error.config.apiData;
        delete error.config.apiData;
      }
      delete error.config.apiPath;
      delete error.config.apiMethod;

      return $http(error.config);
    }

    return Promise.reject(error.response || error);
  }
);

export default $http;
